import * as qs from 'querystring';

import moment from 'moment';

type InputParams = Record<string, string[] | string | boolean | number | Date | null | undefined>;
type QueryParams = Record<string, string>;

export function construct(search: string, newParams: InputParams): string {
  const oldParams = parse(search);
  const params = { ...oldParams };
  for (const [key, value] of Object.entries(newParams)) {
    if (!key) continue;
    if (value === false) {
      params[key] = value.toString();
    } else if (value === null) {
      params[key] = 'null';
    } else if (value === 0) {
      params[key] = '0';
    } else if (!value) {
      delete params[key];
    } else if (value instanceof Date) {
      params[key] = value.toISOString();
    } else if (Array.isArray(value)) {
      params[key] = value.join('|');
    } else {
      params[key] = value.toString();
    }
  }
  return '?' + qs.stringify(params);
}

export function parse(search: string): QueryParams {
  const queryParams = qs.parse(search.slice(1));
  const params: QueryParams = {};
  for (const [key, value] of Object.entries(queryParams)) {
    if (!key) continue;
    const cleanValue = cleanParam(value);
    if (!cleanValue) continue;
    params[key] = cleanValue;
  }
  return params;
}

export function parseList(value: string, defaultValue = undefined) {
  return value ? value.split('|') : defaultValue;
}

export function parseStr(value: string, defaultValue = undefined) {
  return value || defaultValue;
}

export function parseBool(value: string, defaultValue = undefined) {
  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  } else {
    return defaultValue;
  }
}

export function parseNullableStr(value: string, defaultValue = undefined) {
  return value === 'null' ? null : parseStr(value, defaultValue);
}

export function parseNumber(value: string, defaultValue = undefined) {
  const numericValue = Number(value);
  return isNaN(numericValue) ? defaultValue : numericValue;
}

function cleanParam(param?: string | string[]): string | undefined {
  if (param) {
    return Array.isArray(param) ? param[0] : param;
  }
  return param;
}

export function parseDate(value?: string, defaultValue: Date | undefined = undefined) {
  return value ? moment(value).toDate() : defaultValue;
}
